export default "__VITE_ASSET__572f53f9__"